// extracted by mini-css-extract-plugin
export default {"body":"AddChannelModal_body__8CzWs","error":"AddChannelModal_error__PE3MF"};